import React from 'react';
import BulletedItem from './ui/BulletedItem';

const VARIANT_STYLES = {
  blue: {
    bullet: 'text-indigo-500',
    marker: '✦',
    badge: 'bg-indigo-50 text-indigo-700'
  },
  red: {
    bullet: 'text-indigo-500',
    marker: '✦',
    badge: 'bg-slate-100 text-slate-700'
  }
};

export default function PropuestaComparativaCard({
  titulo,
  puntos = [],
  topicId,
  candidatoSide,
  variant = 'blue'
}) {
  const styles = VARIANT_STYLES[variant] ?? VARIANT_STYLES.blue;

  return (
    <div className="relative overflow-hidden rounded-[2rem] border border-slate-100 bg-white p-6 shadow-sm md:p-8">
      <div className="flex justify-between items-center mb-6">
        <h4 className="text-xl font-bold">{titulo}</h4>
        <span className={`${styles.badge} text-[9px] font-bold px-2 py-1 rounded`} aria-hidden="true" />
      </div>
      <ul className="space-y-5">
        {puntos.map((punto, index) => (
          <BulletedItem
            key={`${topicId}-${candidatoSide}-${index}`}
            as="li"
            className="gap-3 text-sm text-slate-600 leading-relaxed"
            marker={styles.marker}
            markerClassName={`${styles.bullet} mt-1`}
          >
            {punto}
          </BulletedItem>
        ))}
      </ul>
    </div>
  );
}
